import React from "react";
import FsLightbox from "fslightbox-react";

export default ({ sources, toggler }) => <FsLightbox toggler={toggler} sources={sources} />;